import { render, staticRenderFns } from "./GoodsTable.vue?vue&type=template&id=1da44c70&scoped=true&"
import script from "./GoodsTable.vue?vue&type=script&lang=js&"
export * from "./GoodsTable.vue?vue&type=script&lang=js&"
import style0 from "./GoodsTable.vue?vue&type=style&index=0&id=1da44c70&scoped=true&lang=css&"
import style1 from "./GoodsTable.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1da44c70",
  null
  
)

export default component.exports